module.exports = __webpack_public_path__ + "static/kubernetes-ea798a7abf761b1b7b965a9f16eee1a6.png";